import {
  Breadcrumb,
  Button,
  Card,
  Col,
  Collapse,
  Divider,
  Dropdown,
  Image,
  Input,
  Popconfirm,
  Row,
  message,
  theme,
} from 'antd';
import React, { useEffect, useState } from 'react';
import AdminSearchBarHeader from '../component/AdminSearchBarHeader';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import routes from '../../../controller/Routes';
import { Icons } from '../../../controller/Images';
import { CloseOutlined, MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { useTestStore } from '../../../store/testReducer';
import AddquestionInSection from '../component/modal/AddquestionInSection';
import { choices, Section } from '../../../controller/enum';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan } from '@fortawesome/free-regular-svg-icons';
import { createTest, updateTestbyid } from '../../../controller/api/testServices';
import { getTechnology } from '../../../controller/api/globalServices';
import { getAdminDetail } from '../../../controller/localStroageHandler';

const AddAndEditTest = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const {
    questions,
    technology_Used,
    testTitle,
    testDetail,
    updateTechnologyUsed,
    updateTestDetail,
    updateTitle,
    updateTest,
    clearStore,
    updateDuration,
    duration,
    updateProfile,
    profile,
  } = useTestStore((state) => state);
  const [technologyList, setTechnologyList] = useState([]);
  const [addQuestionPopup, setQuestionPopUp] = useState(false);
  const [sectionList, setSectionList] = useState([]);
  const { token } = theme.useToken();
  const panelStyle = {
    marginBottom: 10,
    background: 'white',
    borderRadius: token.borderRadiusLG,
    // border: '1px solid #f0f0f0',
    color: 'black',
    fontSize: '14px',
    fontweight: 600,
    boxShadow:
      'rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px',
  };
  const [addquestionindex, setAddQuestionIndex] = useState(null);
  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const [currentSectionName,setCurrentSectionSectionName]=useState("")
  const params = useParams();
const userDetail=getAdminDetail()
useEffect(() => {
   let data = Object.entries(Section);
      let sectionData = data.map((val) => {
        return { key: val[0], label: val[1] }
      })
      setSectionList(sectionData)
      getTechnologyData({ search: '' })
}, []);

 const getTechnologyData = async (params) => {
    await getTechnology(params).then(res => {
      setTechnologyList(res?.data?.result)
    }).catch(err => {
      console.log("err ===>", err)
    })

  }
  const SectionQuestion = (sectionQues, index) => {
    const questionArr = sectionQues?.map((val, quesindex) => {
      return (
        <Collapse.Panel
          key={quesindex.toString()} // Use a unique key for each panel
          header={
            <div className='fw-medium'>
              Q{quesindex + 1} {val.title}
            </div>
          }
          // extra={<MinusOutlined />}
          extra={
            <Popconfirm
              title='Remove the Question'
              description='Are you sure to remove this question in this section?'
              onConfirm={(e) => {
                e.stopPropagation();
                const testData = [...questions];
                const filterQuestion = testData[index].questions?.filter(
                  (item) => item._id !== val._id
                );
                testData[index].questions = [...filterQuestion];
                updateTest(testData);
              }}
              onCancel={(e) => {
                e.stopPropagation();
              }}
              placement='left'
              okText='Yes'
              cancelText='No'
            >
              <MinusOutlined
                style={{ color: 'red' }}
                onClick={(e) => e.stopPropagation()}
              />
            </Popconfirm>
          }
          style={panelStyle}
        >
          <Row gutter={[12, 12]}>
            <Col span={24}>
              {val?.image_url && (
                <Image src={val?.image_url} width={150} height={150} alt='' />
              )}
            </Col>
            <Col span={24}>
              <Row>
                <Col
                  xl={4}
                  lg={4}
                  md={5}
                  sm={7}
                  xs={9}
                  className='text-black fw-medium'
                >
                  Technology Used{' '}
                </Col>
                <Col
                  xl={2}
                  lg={2}
                  md={1}
                  sm={1}
                  xs={1}
                  className='text-black fw-medium'
                >
                  :{' '}
                </Col>
                <Col xl={18} lg={18} md={18} sm={16} xs={14}>
                  <div className='d-flex gap-2 flex-wrap'>
                    {val?.technology?.map((val, index) => {
                      return (
                        <span
                          key={index}
                          className='skill-bg-color text-muted rounded-1 d-flex gap-1'
                          style={{
                            fontSize: '14px',
                            padding: '0px 5px',
                          }}
                        >
                          {val?.name}
                        </span>
                      );
                    })}
                  </div>
                </Col>
              </Row>
            </Col>
            <Col span={24}>
              <Row>
                <Col
                  xl={4}
                  lg={4}
                  md={5}
                  sm={7}
                  xs={9}
                  className='text-black fw-medium'
                >
                  Difficulty
                </Col>
                <Col
                  xl={2}
                  lg={2}
                  md={1}
                  sm={1}
                  xs={1}
                  className='text-black fw-medium'
                >
                  :
                </Col>
                <Col xl={18} lg={18} md={18} sm={16} xs={14}>
                  <span
                    className='skill-bg-color text-muted rounded-1 gap-1 text-capitalize'
                    style={{
                      fontSize: '14px',
                      padding: '0px 5px',
                    }}
                  >
                    {val.difficulty}
                  </span>
                </Col>
              </Row>
            </Col>
            <Col span={24}>
              <Row>
                <Col
                  xl={4}
                  lg={4}
                  md={5}
                  sm={7}
                  xs={9}
                  className='text-black fw-medium'
                >
                  Choice
                </Col>
                <Col
                  xl={2}
                  lg={2}
                  md={1}
                  sm={1}
                  xs={1}
                  className='text-black fw-medium'
                >
                  :
                </Col>
                <Col xl={18} lg={18} md={18} sm={16} xs={14}>
                  <span
                    className='skill-bg-color text-muted rounded-1 text-center gap-1'
                    style={{
                      fontSize: '14px',
                      padding: '0px 5px',
                    }}
                  >
                    {choices[val?.questionType]}
                  </span>
                </Col>
              </Row>
            </Col>
            <Col span={24}>
              <Row>
                <Col
                  xl={4}
                  lg={4}
                  md={5}
                  sm={7}
                  xs={9}
                  className='text-black fw-medium'
                >
                  Option
                </Col>
                <Col
                  xl={2}
                  lg={2}
                  md={1}
                  sm={1}
                  xs={1}
                  className='text-black fw-medium'
                >
                  :
                </Col>
                <Col xl={18} lg={18} md={18} sm={16} xs={14} s>
                  <div className='d-flex gap-2 flex-wrap'>
                    {val?.options?.map((option, optinindex) => {
                      return (
                        <div className='d-flex flex-column gap-2'>
                          <span
                            key={optinindex}
                            className={`rounded-1 d-flex justify-content-center align-items-center gap-1 ${
                              option.is_answer == 'True' ||
                              option.is_answer == true
                                ? 'button-color text-white'
                                : 'skill-bg-color text-muted '
                            }`}
                            style={{
                              fontSize: '14px',
                              padding: '0px 5px',
                            }}
                          >
                            {option?.text}
                          </span>
                          {option?.image_url && (
                            <Image
                              src={option?.image_url}
                              width={50}
                              height={50}
                              alt=''
                            />
                          )}
                        </div>
                      );
                    })}
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Collapse.Panel>
      );
    });
    return questionArr;
  };

  const handleMenuClick = (e) => {
    if (questions?.length) {
      let data = [...questions];
      const checkSectionPersent = data?.filter((val) => {
        if (val?.section.toLowerCase() == e.key?.toLowerCase()) {
          return val;
        }
      });
      if (checkSectionPersent?.length) {
        message.info('This section already Added');
      } else {
        updateTest([
          ...data,
          {
            section: e.key,
            questions: [],
          },
        ]);
      }
    } else {
      updateTest([
        {
          section: e.key,
          questions: [],
        },
      ]);
    }
  };

  const handleSubmit = () => {
    const payload = {
      name: testTitle,
      durationInMins: Number(duration),
      detail: testDetail,
      profile: profile,
      technology: technology_Used?.map((val) => val._id),
      test_questions: questions?.map((val) => {
        let data = { ...val };
        data['questions'] = data?.questions?.map((que) => que?._id);
        return data;
      }),
    };
    if (payload?.name == '' || payload?.name == '' || payload?.name == null) {
      return message.info('Please add the test Name');
    }
    if (
      payload?.detail == '' ||
      payload?.detail == '' ||
      payload?.detail == null
    ) {
      return message.info('Please add the test discription');
    }
    if (
      payload?.durationInMins == '' ||
      payload?.durationInMins == '' ||
      payload?.durationInMins == null
    ) {
      return message.info('Please add the test duration');
    }
    if (
      payload?.profile == '' ||
      payload?.profile == '' ||
      payload?.profile == null
    ) {
      return message.info('Please add the test profile');
    }
    if (payload?.technology?.length == 0) {
      return message.info('please add minimum 1 technology');
    }
    if (payload?.questions?.length == 0) {
      message.info('please add minimum 1 section');
    } else {
      const checkQuestion = payload?.test_questions?.filter((val) => {
        if (val?.questions?.length == 0) {
          return val;
        }
      });
      if (checkQuestion?.length) {
        return message.info('Please add minimum 1 question in section');
      }
    }
    if (params?.id) {
      updateTestbyid(payload,{id:userDetail?.organization_id?._id,testId:params?.id}).then((res) => {
        message.success('Test Updated Successfully');
        clearStore()
        navigate(routes.admin.dashboard.test.self);
      });
    } else {
      createTest(payload,{id:userDetail?.organization_id?._id})
        .then((res) => {
          message.success('Test Created Sucessfully');
          clearStore()
          navigate(routes.admin.dashboard.test.self);
          
        })
        .catch((err) => console.log('err  == =====> ', err));
    }
  };
  const handlePreview = () => {
    if (questions?.length) {
      const checkQuestion = questions?.filter((val) => {
        if (val?.questions?.length == 0) {
          return val;
        }
      });
      if (checkQuestion?.length) {
        return message.info(
          'Please add minimum 1 question in section to preview'
        );
      }
    } else {
      return message.info(
        'please add minimum 1 Section with question to preview'
      );
    }
    navigate(routes?.admin?.preview);
  };
  return (
    <>
      <div className='w-100 h-100 p-xl-4 p-lg-4 p-md-3 p-sm-2 test-create-container  bg-light overflow-y-auto'>
        <AdminSearchBarHeader />
        <Row align={'middle'} className='mt-lg-3 mt-md-2 mt-sm-1 mb-3'>
          <Col
            xl={12}
            lg={12}
            md={10}
            sm={10}
            xs={7}
            className='fs-5 fw-semibold'
          >
            <Breadcrumb
              items={[
                {
                  title: (
                    <Link
                      to={routes.admin.dashboard.test.self}
                      className='text-decoration-none text-capitalize'
                    >
                      Test
                    </Link>
                  ),
                },
                {
                  title: (
                    <div className='text-capitalize'>
                      {location.pathname?.split('/')[4]}
                    </div>
                  ),
                },
              ]}
            />
          </Col>
          <Col
            xl={12}
            lg={12}
            md={14}
            sm={14}
            xs={17}
            className='d-flex justify-content-end gap-2'
          >
            <Row className='w-100' gutter={[12, 12]}>
              <Col span={8}>
                <Button
                  type='text'
                  className='w-100 text-color-custom fs-6 fw-semibold d-flex justify-content-center align-items-center custom-hover-btn'
                  onClick={() => {
                    // clearStore();
                    navigate(routes.admin.dashboard.test.self);
                  }}
                >
                  Discard
                </Button>
              </Col>
              <Col span={8}>
                <Button
                  className='w-100 text-color-custom fs-6 fw-semibold btn-border-color d-flex justify-content-center align-items-center custom-hover-btn'
                  onClick={() => handleSubmit()}
                >
                  Save
                </Button>
              </Col>
              <Col span={8}>
                <Button
                  type='primary'
                  className='w-100 button-color fs-6 fw-semibold btn-border-color d-flex justify-content-center align-items-center custom-hover-btn'
                  onClick={() => handlePreview()}
                >
                  Preview
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <Card>
          <Row gutter={[12, 12]}>
            <Col span={8}>
              <Input.TextArea
                className=' border  border-0 border-bottom bg-light text-black-50 fw-medium'
                placeholder='Untitled Test'
                value={testTitle}
                style={{height:'32px'}}
                onChange={(e) => updateTitle(e.target.value)}
              />
            </Col>
            <Col
              span={16}
              className='d-flex justify-content-end align-items-center gap-2'
            >
              <span>Time:</span>
              <div className='border border-0 border-bottom d-flex p-1 gap-2 align-items-center'>
                <Image src={Icons.timerIcon} alt='' preview={false} />
                <Input
                  style={{ width: '65px' }}
                  className='p-1 border-0'
                  placeholder='Duration'
                  value={duration}
                  onChange={(e) => {
                    const input = e.target.value;
                    if (!isNaN(input) || input === '') {
                      updateDuration(input);
                    }
                  }}
                />
                min
              </div>
            </Col>
            <Col span={24} className='lh-lg'>
              <span className='fw-medium fs-6'>Test Details</span>
              <Input.TextArea
                placeholder='Test Description'
                value={testDetail}
                onChange={(e) => updateTestDetail(e.target.value)}
              />
            </Col>
            <Col xl={15} lg={15} md={18} sm={20} xs={24} className='lh-lg'>
              <span className='fw-medium fs-6'>Profile</span>
              <Input
                className='border border-0 border-bottom text-black-50 fw-medium'
                placeholder='Title'
                value={profile}
                onChange={(e) => updateProfile(e.target.value)}
              />
            </Col>
            <Col xl={15} lg={15} md={18} sm={20} xs={24} className='lh-lg'>
              <span className='fw-medium fs-6'>Technology Used</span>
              <div className='border border-0 border-bottom d-flex p-1'>
                <div className='d-flex gap-2 flex-wrap'>
                  {technology_Used?.map((val, index) => {
                    return (
                      <span
                        key={index}
                        className='skill-bg-color text-muted rounded-1 d-flex gap-1'
                        style={{ fontSize: '14px', padding: '0px 5px' }}
                      >
                        {val?.name}
                        <CloseOutlined
                          onClick={() => {
                            const data = technology_Used?.filter(
                              (item) => val.id !== item.id
                            );
                            updateTechnologyUsed(data);
                          }}
                        />
                      </span>
                    );
                  })}
                  <span>
                    <Input
                      className='border border-0  text-black-50 fw-medium option-input'
                      placeholder='add technology'
                      onChange={(e) =>{getTechnologyData({ search: e.target.value })}}
                    />
                  </span>
                </div>
              </div>
              <div className='d-flex gap-2 flex-wrap p-1'>
                {technologyList?.map((val, index) => {
                  return (
                    <span
                      key={index}
                      className='skill-bg-color text-muted rounded-1'
                      style={{
                        fontSize: '14px',
                        cursor: 'pointer',
                        padding: '0px 5px',
                        cursor: 'pointer',
                      }}
                      onClick={() => {
                        let checkTechology = technology_Used.filter(
                          (item) => val._id === item._id
                        );
                        if (checkTechology?.length) {
                          message.info('You Already Selected This Technology');
                        } else {
                          updateTechnologyUsed([...technology_Used, val]);
                        }
                      }}
                    >
                      {val?.name}
                    </span>
                  );
                })}
              </div>
            </Col>
            {questions?.map((val, index) => {
              return (
                <Col span={24}>
                  <Row align={'middle'}>
                    <Col
                      xl={5}
                      lg={5}
                      md={7}
                      sm={8}
                      xs={12}
                      className='d-flex gap-2 align-items-center'
                    >
                      <span className='fs-5 fw-medium'>{val?.section} </span>
                      <span
                        className='timer-div-bg-color text-color-custom fw-medium rounded-1 d-flex gap-1'
                        style={{
                          fontSize: '14px',
                          padding: '0px 5px',
                        }}
                      >
                        {val?.questions?.length||0} Ques
                      </span>
                    </Col>
                    <Col xl={5} lg={5} md={7} sm={8} xs={12}>
                      <FontAwesomeIcon
                        style={{ cursor: 'pointer' }}
                        icon={faTrashCan}
                        className='text-color-custom'
                        onClick={() => {
                          let data = [...questions];
                          updateTest(
                            data?.filter((val, testIndex) => testIndex != index)
                          );
                        }}
                      />
                    </Col>
                  </Row>
                  <div className='p-2 border-start m-lg-2'>
                    <Collapse
                      bordered={false}
                      // defaultActiveKey={['1']}
                      // onChange={onChange}
                      className='bg-transparent'
                      expandIconPosition={'end'}
                      // items={SectionQuestion(val?.question)}
                    >
                      {SectionQuestion(val?.questions, index)}
                    </Collapse>

                    <Row className='position-relative d-flex justify-content-center align-items-center'>
                      <Divider className='btn-border-color' />
                      <Button
                        className='position-absolute text-color-custom fs-6 fw-semibold btn-border-color d-flex justify-content-center align-items-center custom-hover-btn rounded-5'
                        onClick={() => {
                          setAddQuestionIndex(index);
                          setSelectedQuestion(val.questions);
                          setQuestionPopUp(true);
                          setCurrentSectionSectionName(val?.section)
                        }}
                      >
                        Add New Question <PlusOutlined />
                      </Button>
                    </Row>
                  </div>
                </Col>
              );
            })}
          </Row>
          <Row className='position-relative d-flex justify-content-center align-items-center'>
            <Divider className='btn-border-color' />
            <Dropdown
              menu={{
                items: sectionList,
                onClick: handleMenuClick,
              }}
              overlayClassName='custom-dropdown'
              placement='bottom'
              arrow
            >
              <Button
                className=' position-absolute text-color-custom fs-6 fw-semibold btn-border-color d-flex justify-content-center align-items-center custom-hover-btn rounded-5'
                onClick={(e) => e.preventDefault()}
              >
                Add New Section <PlusOutlined />
              </Button>
            </Dropdown>
          </Row>
        </Card>
      </div>
      {addQuestionPopup && (
        <AddquestionInSection
          addquestionindex={addquestionindex}
          setAddQuestionIndex={setAddQuestionIndex}
          selectedQuestion={selectedQuestion}
          setSelectedQuestion={setSelectedQuestion}
          addQuestionPopup={addQuestionPopup}
          setQuestionPopUp={setQuestionPopUp}
          setCurrentSectionSectionName={setCurrentSectionSectionName}
          currentSectionName={currentSectionName}
        />
      )}
    </>
  );
};
export default AddAndEditTest;
